import React, { Component } from 'react';
import styled from 'styled-components/macro';
import { WithTranslation, withTranslation } from 'react-i18next';

import { distances } from '../../styles/constants';

import BaseFilter from './BaseFilter';
import { H3 } from '../Typography';
import { Radiobutton } from '../Forms';

export interface Option {
    label: string;
    value: string;
}

interface RadiobuttonListFilterProps extends WithTranslation {
    name: string;
    title: string;
    label: string;
    disabled?: boolean;
    options: Option[];
    value: string;
    onApply: (name: string, value: string) => void;
    onDelete: (name: string) => void;
}

interface FilterSelectState {
    pendingSelection: string | undefined;
}

class RadiobuttonListFilter extends Component<RadiobuttonListFilterProps, FilterSelectState> {
    constructor(props: RadiobuttonListFilterProps, context: any) {
        super(props, context);
        this.state = {
            pendingSelection: props.value,
        };
        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle(value: string) {
        this.setState({
            pendingSelection: value,
        });
    }

    render() {
        const { label, title, name, options, onApply, onDelete, disabled, value } = this.props;
        const { pendingSelection } = this.state;

        return (
            <BaseFilter
                initialOpen={!value}
                label={label}
                name={name}
                disabled={disabled}
                onApply={() => onApply(name, pendingSelection || '')}
                onDelete={() => onDelete(name)}
                applyIsDisabled={!pendingSelection}
            >
                <H3>{title}</H3>
                <OptionsContainer>
                    {options.map(option => (
                        <OptionContainer key={option.value}>
                            <Radiobutton
                                key={option.value}
                                name={option.value}
                                label={option.label}
                                value={option.value === pendingSelection}
                                onChange={(name, _) => {
                                    this.handleToggle(name);
                                }}
                            >
                                {option.label}
                            </Radiobutton>
                        </OptionContainer>
                    ))}
                </OptionsContainer>
            </BaseFilter>
        );
    }
}

const OptionContainer = styled.div`
    padding-bottom: ${distances.small};
`;

const OptionsContainer = styled.div`
    margin-top: ${distances.tiny};
`;

export default withTranslation()<React.ComponentType<RadiobuttonListFilterProps>>(RadiobuttonListFilter);
